import { isEmpty } from 'lodash';

export const preloadedStateValidator = (state) => {
    if (isEmpty(state.tags)) {
        // eslint-disable-next-line no-console
        console.error('INVALID preloaded state: state.tags', state.tags)
    }
    return state
}
